import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../../hooks/useApi";
import { toast } from "sonner";

const TYPES = ["episodes", "books", "audio", "gold", "lessons"];
const STATUS_OPTIONS = {
  episodes: ["MACHINE_EXTRACTED_UNREVIEWED", "approved"],
  books: ["pending", "approved"],
  audio: ["UNRESOLVED — AUTHORITATIVE PARTNER OR ASSET EVIDENCE REQUIRED", "approved"],
  gold: ["pending", "approved"],
  lessons: ["staged_unreviewed", "import_pending", "approved"],
};

export default function AdminCatalog() {
  const api = useApi();
  const qc = useQueryClient();
  const [type, setType] = useState("episodes");
  const { data } = useQuery({ queryKey: ["admin-catalog", type], queryFn: async () => (await api.get(`/admin/catalog/${type}`)).data });

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/catalog/${type}/${id}/status`, { status });
      toast.success("Status updated");
      qc.invalidateQueries({ queryKey: ["admin-catalog", type] });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update status");
    }
  };

  return (
    <div data-testid="admin-catalog-page">
      <h1 className="font-display text-display-xs mb-6">Catalog</h1>
      <div className="flex gap-4 mb-6 border-b border-white/10">
        {TYPES.map((t) => (
          <button key={t} data-testid={`admin-catalog-tab-${t}`} onClick={() => setType(t)} className={`pb-3 text-sm uppercase tracking-wide ${type === t ? "text-brandAccent border-b-2 border-brandAccent" : "text-white/70"}`}>
            {t}
          </button>
        ))}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-white/70 uppercase text-xs">
              <th className="pb-3">Title</th>
              <th className="pb-3">Status</th>
              <th className="pb-3">Update</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/10">
            {data?.map((item) => (
              <tr key={item.id} data-testid={`admin-catalog-row-${item.id}`}>
                <td className="py-3 pr-4 max-w-md truncate">{item.title}</td>
                <td className="py-3 pr-4 text-white/75">{(item.review_status || item.status || "").slice(0, 40)}</td>
                <td className="py-3">
                  <select
                    data-testid={`admin-catalog-status-select-${item.id}`}
                    defaultValue=""
                    onChange={(e) => e.target.value && setStatus(item.id, e.target.value)}
                    className="bg-black border border-white/15 text-xs px-2 py-1"
                  >
                    <option value="">Set status…</option>
                    {STATUS_OPTIONS[type].map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!data?.length && <p className="text-white/70 text-sm py-6">No records.</p>}
      </div>
    </div>
  );
}
